import * as React from 'react';
import { DateTime } from 'luxon';
import { SiteRoute } from '@journeyapps/package-types';
import { RoadmapCardWidget } from '../../pages/roadmap/RoadmapCardWidget';
import { useRoadmap } from '../../pages/roadmap/useRoadmap';
import { CardGridWidget } from '../CardGridWidget';
import { HomeSectionHeader } from './HomeSectionHeader';

export const HomeRoadmapSection: React.FC = () => {
  const { roadmap } = useRoadmap();
  const latest = (
    roadmap?.groups.flatMap((group) =>
      group.cards.map((card) => ({
        card,
        product: group.name,
        updatedAt: DateTime.fromISO(card.updatedAt ?? '').toMillis() || 0
      }))
    ) ?? []
  )
    .sort((a, b) => b.updatedAt - a.updatedAt)
    .slice(0, 4);
  if (!latest.length) return null;
  return (
    <section aria-labelledby="home-roadmap">
      <HomeSectionHeader
        id="home-roadmap"
        title="Explore the roadmap."
        to={SiteRoute.ROADMAP}
        linkLabel="See everything that's planned"
      />
      <CardGridWidget columns={4}>
        {latest.map(({ card, product }) => (
          <RoadmapCardWidget
            key={card.id}
            card={card}
            product={product}
            href={`${SiteRoute.ROADMAP}#roadmap-${card.id}`}
          />
        ))}
      </CardGridWidget>
    </section>
  );
};
